<template>
  <HomeLayout>
    <div v-if="loading">
      <ProgressPage/>
    </div>
    <div v-if="!loading">
      <div class="show-soil-consulting margin-at-mobile">
        <div>
          <div class="header border-bottom">
            <div class="d-flex justify-content-between align-items-center">
              <div v-if="service !== null" class="d-flex align-items-center">
                <span class="farm-title">آزمایش {{ exam_type_fa }} برای سرویس {{ service.ser }}</span>
                <span class="farm-area"
                >( {{
                    service.area !== null
                        ? service.area.area + " " + service.area.unit
                        : ""
                  }} )</span
                >
              </div>
              <div
                  class="d-flex align-items-center pointer"
                  @click="backToPrevPage"
              >
                <span class="back-home-link">بازگشت</span>
                <span>
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="10"
                      viewBox="0 0 10 10"
                  >
                    <g
                        id="Iconly_Light_Arrow_-_Down_2"
                        data-name="Iconly/Light/Arrow - Down 2"
                        transform="translate(10) rotate(90)"
                    >
                      <g
                          id="Arrow_-_Down_2"
                          data-name="Arrow - Down 2"
                          transform="translate(2.083 3.542)"
                      >
                        <path
                            id="Stroke_1"
                            data-name="Stroke 1"
                            d="M5.833,0,2.917,2.917,0,0"
                            fill="none"
                            stroke="#7fd2bc"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                            stroke-width="1.2"
                        />
                      </g>
                    </g>
                  </svg>
                </span>
              </div>
            </div>
          </div>
          <div>

            <div class="container">
              <div class="row mb-4">
                <div class="col justify-content-around">
                  <span class="soil-consulting-req-text">
                    تاریخ آزمایش: {{createdAt}} - {{display_date}}
                    <span class="badge mx-5">test</span>
                  </span>
                </div>
              </div>
              <div class="row mb-4">
                <div class="col justify-content-around">
                  <span v-if="url" class="soil-consulting-req-text">
                    <span>
                      برای دانلود
                      <a class="text-primary" :href="url" style="text-decoration: none;">
                        نتیجه
                      </a>
                      کلیک کنید
                    </span>
                    <span class="badge mx-5">test</span>
                  </span>
                  <span v-else class="soil-consulting-req-text">
                    آزمایش شما آماده نیست
                  </span>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </HomeLayout>
</template>

<script>
import HomeLayout from "../layout/HomeLayout";
import {globalMixin} from "../mixins/globalMixin";
import ProgressPage from "../components/UI/ProgressPage";
import Api from "../common/api";

export default {
  name: "ShowSoilExamination",
  components: {ProgressPage, HomeLayout},
  mixins: [globalMixin],
  inject: ["$axios"],
  data() {
    return {
      service: null,
      soilResult: null,
      laboratory: null,
      createdAt: ''
    };
  },
  props: ["id"],
  methods: {
    getService() {
      let self = this;
      Api.singleSoilResult({self: this, id: this.id})
          .then((response) => {
            if (response.status === 200) {
              let data = response.data;
              self.createdAt = data.created_at;
              self.display_date = data.display_date;
              self.service = data.service !== null ? data.service : null;
              self.soilResult = data.result !== null ? data.result : null;
              self.url = data.url !== null ? data.url : null;
              self.exam_type_fa = data.exam_type_fa !== null ? data.exam_type_fa : null;
              self.exam_type = data.exam_type !== null ? data.exam_type : null;
              self.laboratory = data.laboratory !== null ? data.laboratory : null
              self.loading = false;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.toastReturnTxt(error.response);
          });
    },
  },
  created() {
    this.loading = true;
  },
  mounted() {
    this.getService();
  },
};
</script>

<style lang="scss">
@import "src/styles/modules/ShowSoilConsulting/ShowSoilConsulting";
</style>